import { render, staticRenderFns } from "./GodDashboard.vue?vue&type=template&id=608968a3&"
import script from "./GodDashboard.vue?vue&type=script&lang=js&"
export * from "./GodDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports